module.exports = __webpack_public_path__ + "img/IMG_1962_P_L_WoodMatted_MockedUp.fad23dcd.jpg";